import React from "react";
import CardProdyuct from "../../Component/CardProduct/CardProduct";
// import Card from "../Card/Card";
// import { Link } from "react-router-dom";

function Wear() {
  return (
    <div className=" mt-5">
      <div class="container container1 ">
        <div class="row">
          <div class="col-md-4">
            <div className="list-0">
              <hr />
              <p className="">Ready to Wear</p>
              <hr />
              <p> Bottoms</p>
              <hr />
              <p>Ready to Wear</p>
              <hr />
              <p> Bottoms</p>
              <hr />
              <p>Ready to Wear</p>
              <hr />
            </div>
          </div>
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-4">
                <CardProdyuct
                  imgUrl="./image/swiss.jpg"
                  img="./image/wear.jpg"
                  title="Ready To Wear"
                  price="Rs 10,000"
                />
              </div>
              <div class="col-md-4">
                <CardProdyuct
                  imgUrl="./image/swiss.jpg"
                  img="./image/swiss.jpg"
                  title="SWISS LAWN"
                  price="Rs 10,000"
                />
              </div>
              <div class="col-md-4">
                <CardProdyuct
                  imgUrl="./image/swiss.jpg"
                  img="./image/dupattas.jpg"
                  title="DUPATTAS"
                  price="Rs 10,000"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <CardProdyuct
                  imgUrl="./image/swiss.jpg"
                  img="./image/chantele.jpg"
                  title="CHANTELLE"
                  price="Rs 10,000"
                />
              </div>
              <div class="col-md-4">
                <CardProdyuct
                  imgUrl="./image/swiss.jpg"
                  img="./image/bottoms.jpg"
                  title="BOTTOMS"
                  price="Rs 10,000"
                />
              </div>
              <div class="col-md-4">
                <CardProdyuct
                  imgUrl="./image/swiss.jpg"
                  img="./image/special.jpg"
                  title="SPECIAL PRICE"
                  price="Rs 10,000"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <CardProdyuct
                  imgUrl="./image/swiss.jpg"
                  img="./image/chantele.jpg"
                  title="CHANTELLE"
                  price="Rs 10,000"
                />
              </div>
              <div class="col-md-4">
                <CardProdyuct
                  imgUrl="./image/swiss.jpg"
                  img="./image/bottoms.jpg"
                  title="BOTTOMS"
                  price="Rs 10,000"
                />
              </div>
              <div class="col-md-4">
                <CardProdyuct
                  imgUrl="./image/swiss.jpg"
                  img="./image/special.jpg"
                  title="SPECIAL PRICE"
                  price="Rs 10,000"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Wear;
